import script from "./FollowingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowingForm.vue?vue&type=script&setup=true&lang=js"

import "./FollowingForm.vue?vue&type=style&index=0&id=7d499420&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d499420"]])

export default __exports__